module.exports = __webpack_public_path__ + "static/media/glassesRectangle.c0936e74.png";